import { getVideoSteps } from '@settings/services/videoStepServices';
import { useQuery } from '@tanstack/react-query';

export const useGetCvVideoSteps = (enabled: boolean = true) => {
  return useQuery({
    queryKey: ['cv-video-steps'],
    queryFn: getVideoSteps,
    enabled,
  });
};
